import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem, MenuProps, styled, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LessonEditorActionIcon = styled(MoreVertIcon)(() => []);

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'center',
            horizontal: 'left',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
            marginRight: theme.spacing(1.5),
        },
    },
}));

export type MenuAction = 'duplicate' | 'delete';

export interface Props {
    editable: boolean;
    onMenuClicked?: (action: MenuAction) => void;
}

export const LessonEditorSlideActionMenu: React.FC<Props> = ({ editable, onMenuClicked }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Box>
                <Tooltip title={t('lesson.actions.moreOptions')}>
                    <IconButton size='small' onClick={handleClick}>
                        <LessonEditorActionIcon fontSize='small' />
                    </IconButton>
                </Tooltip>
            </Box>

            {open && (
                <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                        onClick={() => {
                            if (!editable) {
                                return;
                            }

                            onMenuClicked?.('duplicate');
                            handleClose();
                        }}
                        disableRipple
                        disabled={!editable}
                    >
                        <ContentCopyIcon fontSize='small' />
                        {t('lesson.actions.duplicate')}
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            if (!editable) {
                                return;
                            }

                            onMenuClicked?.('delete');
                            handleClose();
                        }}
                        disableRipple
                        disabled={!editable}
                    >
                        <DeleteIcon fontSize='small' />
                        {t('lesson.actions.delete')}
                    </MenuItem>
                </StyledMenu>
            )}
        </>
    );
};
